import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetSimilarOffers } from '../shared/repositories/newbuilding-genplan-mvk/v1/get-similar-offers';
export function fetchSimilarFlats(_x) {
  return _fetchSimilarFlats.apply(this, arguments);
}
function _fetchSimilarFlats() {
  _fetchSimilarFlats = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var params, httpApi, logger, _yield$fetchGetSimila, response, statusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _ref.params, httpApi = _ref.httpApi, logger = _ref.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchGetSimilarOffers({
            httpApi: httpApi,
            parameters: params,
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              }
            }
          });
        case 4:
          _yield$fetchGetSimila = _context.sent;
          response = _yield$fetchGetSimila.response;
          statusCode = _yield$fetchGetSimila.statusCode;
          if (!(statusCode !== 200)) {
            _context.next = 9;
            break;
          }
          throw new Error('Ошибка при запросе похожих квартир');
        case 9:
          return _context.abrupt("return", response);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'fetchGetSimilarOffers'
          });
        case 15:
          return _context.abrupt("return", null);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return _fetchSimilarFlats.apply(this, arguments);
}